export default __webpack_public_path__ + "static/media/menu-icon.a072db7b.png";